import axios from "axios";

export let headers = {
  "Tenant-Access-Token": "YzUwZGFlZmYwZGYyYmI2ZjIwMjUxOTc2YzZmNGQwNWYP=",
  "Tenant-Access-Key": "k1hVJoxQJSiuTg",
};

export const api = axios.create({
  baseURL: "https://immersive-game-india.confirmu.com",
  headers,
});

export const BASE_URL = "https://immersive-game-india.confirmu.com";
